<script>
	import model from "../../stores/modelStore";
	import lookups from "../../stores/lookupStore";
	import businesses from "../../stores/businessesStore";
	import {
		projectSettings,
		acceptedFileUploadList,
		yesNoUnsureOptions,
		neverSometimesAlwaysOptions
	} from "../../config";
	import { isValid } from "../../validation";
	import { unformatDate } from "../../helpers/dateHelpers";
	import { registerPageComplete } from "../../tealium";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import RadioGroup from "../../components/RadioGroup.svelte";
	import DatePicker from "../../components/DatePicker.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import TextInput from "../../components/TextInput.svelte";
	import TextArea from "../../components/TextArea.svelte";
	import DropZone from "../../components/DropZone.svelte";
	import AutoCompleteSelector from "../../components/AutoCompleteSelector.svelte";
	import StoreList from "../../components/StoreList.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import SaveAndClose from "../../components/SaveAndClose.svelte";
	import CheckboxButtonList from "../../components/CheckboxButtonList.svelte";

	export let pageName = null;
	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let buttons = null;
	let validated = false,
		dateFinishValid = true,
		dateFinishError = false;

	const storeLookupUrl = `/api/store-lookup?q=`;

	const id = "fileUploader";
	const options = {
		url: "/api/file-upload?token=" + $model.registrationToken,
		acceptedFiles: acceptedFileUploadList,
		fileUploadToken: $model.registrationToken
	};

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	$model.documentList = $model.documentList || [];
	$model.currentBusiness = null;

	// const classificationOtherId = $lookups.classification.filter((l) => l.lookupName === "Other")[0].id;

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = [...isValid()];

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(response);
			} else {
				registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
	$: {
		console.log($model);
	}

	$: {
		if ($model.selectedBusinesses) {
			$model.selectedBusinesses.sort((a, b) => a - b);
		}
	}

	import { onMount, onDestroy } from "svelte";

	onMount(() => {
		console.log("Component mounted");
		window.scrollTo({ top: 0, behavior: "smooth" });
	});

	onDestroy(() => {
		console.log("Component destroyed");
	});
</script>

<PageSection>
	<Form {disabled} id="form-action-specific" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName} Shift Class Actions</h4>

				<h1 class="text-center">Employment</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="confirmation-box-shadow">
			<FormColumn>
				<YesNoGroup
					{required}
					{disabled}
					name="RelevantPeriod"
					label="Did you work in South Australia between November 2019 and 31 December 2023 (the “Relevant Period”)?"
					bind:value={$model.relevantPeriod} />
			</FormColumn>
		</FormRow>

		{#if $model.relevantPeriod == "No"}
			<!-- <FormRow>
				<FormColumn> -->
			<p class="greyBackground">
				Thank you for your interest in this investigation. At this stage, our investigation only relates to
				individuals who worked on a Sunday in South Australia during the Relevant Period. If you believe you
				have a claim we might be able to assist with, please contact us via email at SAsundaysCA@shine.com.au or
				by phone on 1800 750 837.
			</p>
			<!-- </FormColumn>
			</FormRow> -->
		{/if}

		{#if $model.relevantPeriod != "No"}
			<div style="margin-top: 25px;">
				<label for="Employment"
					>Please select all the relevant businesses you worked at in South Australia.</label>
				<!-- <div>
					<p class="sml-text no-margin">Note: Please select on On The Run if you worked at:</p>
					<ul class="sml-text">
						<li>
							Any On The Run service centre (also referred to as a petrol station or convenience store).
							This includes fast food outlets in On The Run service centres, for example, Hungry Jack’s,
							Chatime, Subway etc
						</li>
						<li>Any Krispy Kreme or Subway outlet in South Australia operated by On The Run</li>
					</ul>
				</div> -->
			</div>

			<FormRow class="confirmation-box-shadow" style="margin-top: 12px;">
				<FormColumn>
					<CheckboxButtonList
						{disabled}
						cols="1"
						name="Employment"
						label=""
						bind:selected={$model.selectedBusinesses}
						optionList={[...$businesses]}
						validator="checkboxRequired"
						validatorValue="1"
						validatorMessage="At least one selection is required"
						validatorTarget=".culture-error"
						valueProperty="businessId"
						labelProperty="businessName" />
				</FormColumn>
			</FormRow>

			<FormRow class="confirmation-hide">
				<FormColumn>
					<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Next" : "Next"} />
				</FormColumn>
			</FormRow>
		{/if}
	</Form>
</PageSection>

<style>
	label span.isrequired {
		color: var(--color-error);
		left: 4px;
		position: relative;
		font-size: 1.2em;
	}

	.greyBackground {
		background-color: lightgray;
		padding: 12px;
		border-radius: 2px;
	}

	.no-margin {
		margin: 3px;
	}

	.sml-text {
		font-size: 0.8em;
	}
</style>
